var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.2 22.7",
    style: {
      enableBackground: "new 0 0 27.2 22.7"
    },
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "secure",
    transform: "translate(0.75 0.75)",
    className: "st0",
    d: "M25.7,21.9H5.2c-0.4,0-0.8-0.3-0.8-0.8v-8.5 c0-0.4,0.3-0.8,0.8-0.8h20.5c0.4,0,0.8,0.3,0.8,0.8v8.5C26.5,21.6,26.2,21.9,25.7,21.9z M6,20.4h19v-7H6V20.4z M8.9,17.2l-1.7-0.5 l0.3-0.9l1.7,0.7l-0.1-2h0.9l-0.1,2l1.7-0.6l0.3,0.9l-1.8,0.5l1.1,1.6l-0.8,0.6l-1.1-1.7l-1,1.6l-0.8-0.5L8.9,17.2z M14.8,17.2 l-1.7-0.5l0.3-0.9l1.7,0.7l-0.1-2H16l-0.1,2l1.7-0.6l0.3,0.9l-1.8,0.5l1.1,1.6l-0.8,0.6l-1.1-1.7l-1,1.6l-0.8-0.5L14.8,17.2z  M20.7,17.2L19,16.7l0.3-0.9l1.7,0.7l-0.1-2h0.9l-0.1,2l1.7-0.6l0.3,0.9l-1.8,0.5l1.1,1.6l-0.8,0.6l-1.1-1.7l-1,1.6l-0.8-0.5 L20.7,17.2z M13.1,5.8h-1.4c0-0.7,0-3.4-1.6-5.1C9.2-0.3,8-0.7,6.4-0.7c-1.5,0-2.8,0.5-3.6,1.5C1.3,2.5,1.4,5.1,1.4,5.8H0 c-0.4,0-0.8,0.3-0.8,0.8v12.5c0,0.4,0.3,0.8,0.8,0.8h2.3c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8H0.8v-11h11.6v3.1 c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8V6.6C13.9,6.2,13.5,5.8,13.1,5.8z M3.9,1.7c0.6-0.7,1.4-1,2.5-1c1.1,0,2,0.3,2.6,1 c1.3,1.4,1.2,3.7,1.2,4.1H2.9C2.9,5.6,2.7,3.2,3.9,1.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.d8c7ab7c6de128cca917dae052d9cb08.svg";
export { ForwardRef as ReactComponent };